<template>

    <SubHeader title="Liste des Chats" :breads="[{ name: 'ListChat' }]" :action="{}" />
    <!-- <div class="row">
        <div class="col-md-12">
            <p>Chat</p>
        </div>
    </div> -->
    <div class="row">
        <div class="col-sm-3">
            <div class="card">
                <!-- Header -->
                <div class="card-header card-header-content-between">
                    <h4 class="card-header-title">Liste des conversations</h4>
                </div>
                <!-- End Header -->

                <!-- Body -->
                <div class="card-body card-body-height" style="height: 65vh;padding: 0px">

                    <!-- Step -->
                    <div v-if="isLoading" class=""
                        style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>


                    <div class="" v-else-if="isSuccess">
                        <div style="display: flex;padding: 10px 8px"
                            class=" align-items-center justify card-hover-effect" @click="setCurrentChat(item)"
                            v-for="(item, i) in items" :key="i">
                            <div class="">
                                <div class=" step-icon-soft-primary"
                                    style="min-height: 58px;width: 58px;text-align: center;border-radius: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;font-weight: bolder;">

                                    <i class="bi bi-person-circle" style="font-size: 30px;"></i>
                                </div>
                            </div>
                            <div class="" style="flex: 1 auto; padding: 0px 10px;">
                                <div class="step-content">
                                    <h5 class="step-title" style="font-weight: bolder">
                                        <a class=" text-dark" href="#">{{ item.phone }}</a>
                                    </h5>


                                    <span class="text-muted small text-uppercase">{{ formatDate(item.created_at)
                                        }}</span>&nbsp;&nbsp;
                                    <span v-if="item.count_message > 0"
                                        class="text-white small text-uppercase bg-danger rounded-pill p-1">{{item.count_message}}</span>

                                    <!-- <span v-else class="text-white small text-uppercase bg-danger rounded-pill p-1">{{ item.count_message }}</span> -->

                                </div>
                            </div>
                            <div class="divider"></div>


                        </div>

                    </div>
                    <b-pagination :limit="2" :keepLength="true" :data="userActiviteCurrentItems ?? {}"
                        @pagination-change-page="getResults" />
                </div>


                <!-- End Footer -->
            </div>
        </div>
        <template v-if="!currentChat">
            <div class="col-sm-6">
                <div class="card">
                    <div class="card-header">

                    </div>
                    <div class="card-body card-body-height" style="height: 65vh;padding: 0px">
                        <div
                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <h2 class="text-muted">Aucune conversation</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card">
                    <div class="card-header">

                    </div>
                    <div class="card-body card-body-height" style="height: 65vh;padding: 0px">
                        <div
                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <h2 class="text-muted"></h2>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="col-sm-6">
                <div class="card">
                    <div class="card-header">
                        <div class="" style="display: flex;justify-content: space-between;align-items: center;">
                            <div style="display: flex;" class=" align-items-center justify ">
                                <div class="">
                                    <div class=" step-icon-soft-primary"
                                        style="min-height: 28px;width: 28px;text-align: center;border-radius: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;font-weight: bolder;">
                                        <i class="bi bi-person-circle" style="font-size: 20px;"></i>
                                    </div>
                                </div>
                                <div class="" style="flex: 1 auto; padding: 0px 10px;">
                                    <div class="step-content">
                                        <h5 style="font-weight: bolder">
                                            <a class=" text-dark" href="#">{{ currentChat.phone }}</a>
                                        </h5>
                                    </div>
                                </div>
                                <div class="divider"></div>


                            </div>

                            <div v-if="chatShowIsLoading" class="" style="">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div class="d-flex" v-else-if="chatShowItems.messages?.length">

                                <div><button class=" btn btn-primary mx-1" @click="this.toggleModal = true">Convertir
                                        plainte</button></div>
                                <div> <button class="btn btn-soft-dark"
                                        @click="this.currentChat = null">Ignorer</button></div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-body-height"
                        :style="{ 'height': '65vh', 'padding': '0px', 'background-image': `url(${logo}) `, 'backgroundRepeat': 'no-repeat', 'backgroundSize': '300px', 'backgroundPosition': 'center' }">

                        <div v-if="chatShowIsLoading" class=""
                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div v-else-if="!chatShowItems.messages?.length" class=""
                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;padding-bottom: 100px;">
                            <h2>Cette conversation ne dispose d'aucun message</h2>
                        </div>


                        <div class="" v-else>

                            <div class="" v-for="(message, i) in chatShowItems.messages" :key="i">
                                <div
                                    :class="['row ', message.sender_id === message.chat_id ? ' justify-content-start ' : 'justify-content-end text-end']">
                                    <div class="px-2 py-2"
                                        :class="message.sender_id === message.chat_id ? 'bg-dark text-white ' : ' bg-soft-primary text-black'"
                                        style="max-width: 70%;width: fit-content;margin: 10px 20px;border-radius: 10px;">
                                        <div class="text-muted" style="font-weight: 900; font-size: 12px;"> {{
                                            message.sender_name }}</div>
                                        <div class="mt-1" v-if="message.type === 'chat'">
                                            {{ cleanContent(message.content) }}
                                        </div>
                                        <div class="mt-1" v-else-if="['png', 'webp'].includes(message.type)">
                                            <img :src="fileServeur + message.content" alt="Image"
                                                class="message-image" />
                                        </div>
                                        <div class="mt-1" v-else-if="message.type === 'pdf'">
                                            <a :href="fileServeur + message.content" target="_blank"
                                                class="message-link">
                                                📄 Voir le PDF
                                            </a>
                                        </div>

                                        <div class="mt-1" v-else-if="message.type === 'mp3'">
                                            <audio controls class="message-audio">
                                                <source :src="fileServeur + message.content" type="audio/mpeg">
                                                Votre navigateur ne prend pas en charge la
                                                lecture audio.
                                            </audio>
                                        </div>

                                        <div v-else-if="message.type === 'mp4'">
                                            <video controls class="message-video">
                                                <source :src="fileServeur + message.content" type="video/mp4">
                                                Votre navigateur ne prend pas en charge la
                                                lecture vidéo.
                                            </video>
                                        </div>

                                        <p v-else>⚠️ Contenu non pris en charge</p>


                                        <div class="mt-2" style="font-weight: 200; font-size: 10px;">
                                            {{ formatDate(message.date) }}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card">
                    <div class="card-header">Liste des plaintes <span class="badge bg-danger text-white">
                            {{ chatShowItems?.complaint_count?.length ?? '' }}</span></div>
                    <div class="card-body card-body-height" style="height: 65vh;padding: 0px">

                        <div v-if="chatShowIsLoading" class=""
                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <ul class="step step-icon-xs mb-0 mx-1 my-3" v-else>
                            <li class="step-item" v-for="(plaint, i) in chatShowItems.complaint_count" :key="i">
                                <div class="step-content-wrapper">
                                    <span class="step-icon  step-icon-soft-dark">
                                        #{{ i + 1 }}
                                    </span>

                                    <div class="step-content">
                                        <h5 class="step-title d-inline-block text-truncate " style="max-width: 250px;">
                                            <router-link
                                                :to="{ name: 'DossierShow', params: { id: plaint.complaint_id } }"
                                                class="text-dark">{{ plaint.complaint_data }}</router-link>
                                        </h5>

                                        <div class="fs-5 mb-1">{{ plaint.created_at }}
                                            <div class=""> <span
                                                    class="badge bg-soft-success text-success rounded-pill"><span
                                                        class="legend-indicator bg-success"></span>{{
                                                    plaint.phone }}</span></div>
                                        </div>

                                        <div class="text-muted small">
                                            {{ plaint.phone }}</div>

                                    </div>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </template>
        <!-- .....start Modal of confirmation....... -->
        <Modal>

            <div class="text-center" v-if="!updateIsLoading && currentChat">
                <span>Voulez-vous vraiment convertir la conversation avec le numéro <b class="text-primary">
                        {{ currentChat?.phone }}</b> en plainte ?
                </span>

            </div>
            <div class="spinner-grow" role="status" v-else>
                <span class="visually-hidden">Loading...</span>
            </div>
            <template #btn>

                <button type="button" :disabled="updateIsLoading || !currentChat" class="btn btn-primary"
                    @click="submitModal">
                    <span v-if="updateIsLoading" class="spinner-grow" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </span>
                    <span v-else>
                        Oui, Convertir
                    </span>
                </button>


            </template>
        </Modal>
        <!-- ....End Modal of confirmation ........ -->
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Modal from "@/widgets/Modal";
import logo from "@/assets/logos/logo_.png"
import notify from "@/utils/notify.js"


export default {
    name: "WhatsappList",
    components: {
        SubHeader,
        Modal
    },

    data() {
        return {
            // cols: [
            //     { field: 'phone', title: 'Numero du citoyen' },
            //     { field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },
            // ],
            // items:[],
            searchWord: null,
            fileServeur: process.env.VUE_APP_FILE_SERVER_ULR ?? "",
            chat: {
                id: null
            },
            currentChat: null,
            logo,
            conversation: null,
        }

    },
    computed: {
        ...mapFields("chat/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"
        }),
        ...mapFields("chat/show", {
            chatShowItems: "item",
            chatShowIsLoading: "isLoading",
            chatShowIsSuccess: "isSuccess",
        }),

        ...mapFields("chat/update", {
            updateIsLoading: "isLoading",
            updateIsUpdated: "isUpdated",
            updateIsSuccess: "isSuccess",
            updateShowMessage: "showMessage",
            updateMessage: "message",
            updateItem: "update"
        }),
        ...mapFields("widget/modal", {
            toggleModal: "showMessage",
        }),
    },
    watch: {

        currentChat(val) {
            if (val?.code) {
                this.getChatShow(val.code)

            } else {
                this.currentChat = null
            }
        },
        updateIsUpdated(val) {
            if (val) {
                this.toggleModal = false;
                this.currentChat = null
                this.getChat()
                notify(`<div class="ml-2" style="margin-left:10px"><b>Super,La plainte a été énregistrée</b><a href="/dossier/${this.updateItem?.id ?? 0}/show" target="_blank" class="badge bg-soft-primary text-primary ">Consulter</a></div>`)
               
            }
        }
    },

    methods: {
        ...mapActions({
            getChat: "chat/list/getAll",
            reset: "chat/list/resetData",
            resetUpdate: "chat/update/resetData",
            resetShow: "chat/show/resetData",
            getChatShow: "chat/show/getOne",
            updateChat: "chat/update/update",
        }),

        setCurrentChat(item) {
            this.currentChat = item;
        },
        formatDate(date) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return new Date(date).toLocaleDateString('fr-FR', options);
        },
        cleanContent(content) {
            const unquotedContent = content.replace(/^"(.*)"$/, '$1');
            try {
                return JSON.parse(`"${unquotedContent}"`);
            } catch (error) {
                console.error("Erreur lors du décodage des séquences Unicode :", error);
                return unquotedContent;
            }
        },

        showModal() {
            this.toggleModal = true
        },
        submitModal() {
            // this.updateChat(this.currentChat)
            this.formatMessages();
            if (!this.updateIsLoading && this.currentChat) {
                this.$router.push({ name: 'DossierNewCallCenter', query: { code: this.chatShowItems.code, chat: this.chatShowItems.id},});
            }
        },

        formatMessages() { 
            this.conversation = this.chatShowItems.messages
            .map((message) => {
                const role = message.sender_id === message.chat_id ? "Plaignant" : "Agent";
                const content = message.content.replace(/(^"|"$)/g, "");
                return `${role} : ${content}`;
            })
            .join("\n"); 
        },
       

        
    },
    mounted() {
        this.getChat()
    },
    unmounted() {
        this.reset()
        this.resetUpdate()
        this.resetShow()
    }
}
</script>
<style scoped>
.card-hover-effect {
    padding: 5px;
    transition: all;
    transition-duration: 100ms;
    transition-delay: 10ms;
    box-shadow: 1px 1px 0px lightgray
}

.card-hover-effect:hover {
    scale: 0.97;
    cursor: pointer;


}

.chat-container {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 10px;
    /* style="height: 63vh;padding: 0px" */
}

.chat-message {
    max-width: 70%;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
}

.chat-message.sent {
    align-self: flex-end;
    background-color: #d1e7dd;
}

.chat-message.received {
    align-self: flex-start;
    background-color: #fbf6f6;
}

.message-content p {
    margin: 0;
}

.message-content small {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    color: #6c757d;
}

.message-image {
    max-width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 8px;
}

.message-video {
    width: 100%;
    max-width: 400px;
    max-height: 300px;
    border-radius: 8px;
}

.message-audio {
    width: 100%;
    max-width: 400px;
}

.message-link {
    color: #0d6efd;
    text-decoration: none;
    word-wrap: break-word;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.loading-spinner {
    color: white;
    font-size: 24px;
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid white;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
